"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.METRICS_UNTITLED_GROUP = exports.METRICS_DELETE_TOOLTIP = exports.METRICS_PAGE_DESCRIPTION = exports.METRICS_BADGE_LABELS = void 0;
exports.METRICS_BADGE_LABELS = {
    predefined: 'Predefined',
    'ai-generated': 'AI Generated',
};
exports.METRICS_PAGE_DESCRIPTION = 'Curate the metric groups that roll up raw signals captured from your AI ' +
    'use cases. Signals themselves are read-only — they originate in the ' +
    'source use case definitions — so admins focus on grouping: create new ' +
    'groups, rename them, and reassign signals so each KPI you report on is ' +
    'backed by a clean, well-named bucket. Click Save Changes to publish the ' +
    'grouping; AI-generated groups are flagged with a sparkles icon for ' +
    'traceability.';
exports.METRICS_DELETE_TOOLTIP = 'Only metric groups without any signals can be deleted. Move all signals ' +
    'out of a group before removing it.';
exports.METRICS_UNTITLED_GROUP = 'Untitled Group';
